jQuery(function($){
  $( "input" ).blur(function() {
    if($(this).val()){
      $(this).closest('div[class^="form-group"]').addClass("active");
    }else{
      $(this).closest('div[class^="form-group"]').removeClass("active");
    }
  });

  $( "input" ).focus(function() {
      $(this).closest('div[class^="form-group"]').addClass("active");
    });
});
